<!-- 
	This is the sign up page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div>
    <!-- Sign Up Image And Headings -->
    <div
      class="sign-up-header"
      style="background-image: url('images/bg-signup.jpg')"
    >
      <div class="content">
        <h1 class="mb-5">Sign Up</h1>
        <p class="text-lg">
          Use these awesome forms to login or create new account in your project
          for free.
        </p>
      </div>
    </div>
    <!-- / Sign Up Image And Headings -->

    <!-- Sign Up Form -->
    <a-card
      :bordered="false"
      class="card-signup header-solid h-full"
      :bodyStyle="{ paddingTop: 0 }"
    >
      <template #title>
        <h5 v-show="mode == 'reg'" class="font-semibold text-center">Register With</h5>
        <h5 v-show="mode == 'ver'" class="font-semibold text-center">We sent a verification code to your email</h5>
      </template>
      <div v-show="mode == 'reg'" class="sign-up-gateways">
        <!-- <a-button>
					<img src="images/logos/logos-facebook.svg" alt="">
				</a-button>
    			<a-button>
					<img src="images/logos/logo-apple.svg" alt="">
				</a-button> -->
        <a-button>
          <img src="images/logos/Google__G__Logo.svg.png" alt="" />
        </a-button>
      </div>
      <p
        v-show="mode == 'reg'"
        class="text-center my-25 font-semibold text-muted"
      >
        Or
      </p>
      <h5
        v-show="mode == 'dev'"
        class="text-center my-25 font-semibold text-muted"
      >
        Please Enter Activation Code
      </h5>
      <p
        v-show="mode == 'dev'"
        class="text-center my-25 font-semibold text-muted"
      >
        check your email and read the code
      </p>
      <a-form
        id="components-form-demo-normal-login"
        :form="form"
        class="login-form"
        @submit="handleSubmit"
      >
        <!-- <a-form-item class="mb-10">
					<a-input
						v-decorator="[
						'name',
						{ rules: [{ required: true, message: 'Please input your name!' }] },
						]"
						placeholder="Name"
					>
					</a-input>
				</a-form-item> -->
        <a-form-item v-show="mode == 'reg'" class="mb-10">
          <a-input
            v-model="username"
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: 'Please input your email!' },
                ],
              },
            ]"
            placeholder="Email"
          >
          </a-input>
        </a-form-item>
        <a-form-item v-show="mode == 'reg'" class="mb-5">
          <a-input
            v-decorator="[
              'password',
              {
                rules: [
                  { required: true, message: 'Please input your Password!' },
                ],
              },
            ]"
            type="password"
            placeholder="Password"
            v-model="password"
          >
          </a-input>
        </a-form-item>
        <a-form-item v-show="mode == 'reg'" class="mb-10">
          <a-checkbox
            v-decorator="[
              'remember',
              {
                valuePropName: 'checked',
                initialValue: true,
              },
            ]"
          >
            I agree the
            <a href="#" class="font-bold text-dark">Terms and Conditions</a>
          </a-checkbox>
        </a-form-item>
        <a-form-item v-show="mode == 'ver'" class="mb-10">
          <a-input v-model="verifyCode" placeholder="Please enter Code">
          </a-input>
        </a-form-item>

        <a-form-item>
          <a-alert
            type="success"
            v-show="successMsg != ''"
            :message="successMsg"
            banner
          />
          <a-alert
            type="error"
            v-show="errMsg != ''"
            :message="errMsg"
            banner
          />
        </a-form-item>
        <a-form-item v-show="mode == 'reg'">
          <a-button
            type="primary"
            block
            html-type="submit"
            class="login-form-button"
            :loading="regIsLoading"
          >
            SIGN UP
          </a-button>
        </a-form-item>

        <a-form-item v-show="mode == 'ver'">
          <a-button
            type="primary"
            block
            @click="verify"
            class="login-form-button"
            :loading="verIsLoading"
          >
            Send And Active Account
          </a-button>
        </a-form-item>
      </a-form>
      <p class="font-semibold text-muted text-center">
        Already have an account?
        <router-link to="/sign-in" class="font-bold text-dark"
          >Sign In</router-link
        >
      </p>
    </a-card>
    <!-- / Sign Up Form -->
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      regIsLoading: false,
      verIsLoading: false,
      mode: "reg",
      username: "",
      password: "",
      verifyCode: "",
      repeatPassword: "",
      errMsg: "",
      successMsg: "",
    };
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  methods: {
    ...mapMutations(["setUser", "setToken", "setRefreshToken"]),
    // Handles input validation after submission.
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.register(values.email, values.password, values.password);
        }
      });
    },
    register(username, password, repeatPassword) {
      this.regIsLoading = true;
      this.errMsg = "";
      this.success = "";

      const headers = this.getHeaders();

      this.axios
        .post(
          `/public/auth/register`,
          {
            username,
            password,
            repeatPassword,
            usernameType: "email",
          },
          { headers }
        )
        .then(({ data }) => {
          console.log(data);
          if (data.success && data.message == "verify_account") {
            this.mode = "ver";
            this.regIsLoading = false;
          } else {
            this.regIsLoading = false;
          }
        })
        .catch((error) => {
          this.regIsLoading = false;
          console.log(error);
          if (error.response?.data?.message) {
            console.log(error.response?.data);
            this.errMsg = error.response.data.message;
            this.$message.error(error.response.data.message);
          } else {
            this.errMsg = error.message;
            this.$message.error(error.message);
          }
        });
    },
    verify() {
      this.verIsLoading = true;
      this.errMsg = "";
      this.success = "";
      const headers = this.getHeaders();
      
      this.axios
        .post(
          `/public/auth/verify/email`,
          {
            username: this.username,
            token: this.verifyCode,
          },
          { headers }
        )
        .then(({ data }) => {
          console.log(data);
          if (data.success) {
            this.setToken("SIGNED_IN");
            //this.setRefreshToken(data.result.refreshJwt);
            this.setUser(data.result.user);
            this.$router.push("/dashboard");
            this.verIsLoading = false;
          } else {
            this.verIsLoading = false;
          }
        })
        .catch((error) => {
          this.verIsLoading = false;
          console.log(error);
          if (error.response?.data?.message) {
            console.log(error.response?.data);
            this.errMsg = error.response.data.message;
            this.$message.error(error.response.data.message);
          } else {
            this.errMsg = error.message;
            this.$message.error(error.message);
          }
        });
    },
  },
  async mounted() {
    if(!this.registrationIsActive){
       this.$router.push("/");
    }
    if (this.isLoggedIn) {
      this.$router.push("/dashboard");
    }
  },
};
</script>

<style lang="scss"></style>
